import React from 'react';
import { IconProps } from '../types/types';

const ARV: React.FC<IconProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" role="img" {...props}><path d="m13.607 14.268-1.822-3.155h3.55l2.753 4.768A9.954 9.954 0 0 0 20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 2.198.71 4.23 1.912 5.881L10 1.873l4.827 8.36h-3.549l-1.32-2.286-1.828 3.166h2.64l1.822 3.155H6.308l-2.2 3.811A9.954 9.954 0 0 0 10 20a9.953 9.953 0 0 0 5.833-1.877l-2.226-3.855Z" fill="#739574"/></svg>
);

export default ARV;
